/**
 * Stable refusal reason codes of the embeddable Central widget (D426 W-EMBED-API, ADR-0067).
 *
 * Every refusal the public widget surface or the embed-configuration kernel produces carries exactly one of these
 * fixed tokens (`[A-Z0-9_]`), so the widget runtime (D427) and the Admin (D429) branch on a code, never on prose, and
 * the server can emit them as the RFC 7807 `reasonCode` extension member. Adding a code is additive; renaming one is a
 * breaking change for every embedded widget in the wild.
 */
export const WIDGET_REASON_CODES = [
    // ---- key + origin (the embed gate) ----
    'WIDGET_KEY_MISSING',
    'WIDGET_KEY_INVALID',
    'WIDGET_KEY_REVOKED',
    'WIDGET_ORIGIN_MISSING',
    'WIDGET_ORIGIN_NOT_ALLOWED',
    // ---- visitor session ----
    'WIDGET_SESSION_MISSING',
    'WIDGET_SESSION_INVALID',
    'WIDGET_SESSION_EXPIRED',
    'WIDGET_SESSION_ENDED',
    'WIDGET_CONSENT_REQUIRED',
    'WIDGET_SUBJECT_NOT_OFFERED',
    // ---- message text ----
    'WIDGET_MESSAGE_EMPTY',
    'WIDGET_MESSAGE_TOO_LONG',
    'WIDGET_MESSAGE_INVALID_CHARS',
    // ---- abuse bounds ----
    'WIDGET_RATE_LIMITED',
    'WIDGET_MESSAGE_BUDGET_EXHAUSTED',
    // ---- conversation ----
    'WIDGET_CONVERSATION_CLOSED',
    'WIDGET_NOT_A_WIDGET_CONVERSATION',
    // ---- embed configuration (operator side) ----
    'WIDGET_NAME_INVALID',
    'WIDGET_ORIGIN_MALFORMED',
    'WIDGET_ORIGIN_WILDCARD',
    'WIDGET_ORIGIN_INSECURE',
    'WIDGET_ORIGINS_EMPTY',
    'WIDGET_TOO_MANY_ORIGINS',
    'WIDGET_SETTINGS_INVALID',
    'WIDGET_EMBED_REVOKED',
    // D449 (E-01, ADR-0078): the embed's market — a well-formed `cc:slug` the deployment registered.
    'WIDGET_MARKET_INVALID',
    // D850 (L5-002): an embed without a market opened its conversations at the platform, where the market's agents are refused them - a new embed must name its market.
    'WIDGET_MARKET_REQUIRED',
    // D853 (phase A): an embed serves a COUNTRY (its city is resolved per conversation); a new embed names its country (or a market, which implies it).
    'WIDGET_COUNTRY_REQUIRED',
    'WIDGET_COUNTRY_INVALID',
    // D853: the city a visitor picked, or a page named, is not one the embed's country serves.
    'WIDGET_MARKET_NOT_SERVED',
    // D853: what the visitor typed as a city is not a city name / a position is not a position.
    'WIDGET_CITY_INVALID',
    'WIDGET_LOCATION_INVALID',
];
export const refuse = (code, message) => ({ code, message });
export function isWidgetReasonCode(v) {
    return typeof v === 'string' && WIDGET_REASON_CODES.includes(v);
}
//# sourceMappingURL=reasons.js.map